import React, {useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../../../reducers";
import {withTranslation} from "react-i18next";
import CartButtonDeliveryInfo from "./CartButtonDeliveryInfo";
import CartButtonPickUpInfo from "./CartButtonPickUpInfo";
import CartButtonRoomServiceInfo from "./CartButtonRoomServiceInfo";
import CartButtonDineInInfo from "./CartButtonDineInInfo";
import CartChangeOrderDetailsModal from "../CartChangeOrderDetailsModal/CartChangeOrderDetailsModal";
import StoreUtils from "../../../../services/Store/StoreUtils";
import {getStoreConfig} from "../../../../services/Store/reducer";
import CartButtonTemporarilyClosedInfo from "./CartButtonTemporarilyClosedInfo";
import {getSession} from "../../../../services/Session/reducer";
import {createKeyDownHandler} from "../../../../utils/keyDownHanlder";

interface OwnProps {
    menuId: number | undefined;
}

type Props = ReturnType<typeof mapStateToProps> & DispatchProp & OwnProps;

const CartButtonInfoComponent = ({config, session, menuId}: Props) => {
    const [showOrderDetailsModal, setShowOrderDetailsModal] = useState(false);
    const orderType = session.order_type;

    const drawInfoDependingOnOrderType = () => {
        if (StoreUtils.isPaused(config)) return (
            <CartButtonTemporarilyClosedInfo/>
        );

        switch (orderType) {
            case 'DELIVERY':
                return <CartButtonDeliveryInfo handleShowOrderDetailsModal={handleShowOrderDetailsModal}
                                               handleOnKeyDown={handleOnKeyDown}/>;
            case 'PICK_UP':
                return <CartButtonPickUpInfo handleShowOrderDetailsModal={handleShowOrderDetailsModal}
                                             handleOnKeyDown={handleOnKeyDown}/>;
            case 'ROOM_SERVICE':
                return <CartButtonRoomServiceInfo handleShowOrderDetailsModal={handleShowOrderDetailsModal}
                                                  handleOnKeyDown={handleOnKeyDown}/>;
            case 'DINE_IN':
                return <CartButtonDineInInfo handleShowOrderDetailsModal={handleShowOrderDetailsModal}
                                             handleOnKeyDown={handleOnKeyDown}/>;
            default:
                return <></>
        }
    }

    const handleShowOrderDetailsModal = () => {
        setShowOrderDetailsModal(true)
    }

    const handleOnKeyDown = createKeyDownHandler<HTMLDivElement>({
        keys: ["Enter", " "],
        preventDefault: true,
        action: () => handleShowOrderDetailsModal()
    });

    return (
        <>
            {
                showOrderDetailsModal && <CartChangeOrderDetailsModal show={showOrderDetailsModal} menuId={menuId}
                                                                      onHide={() => setShowOrderDetailsModal(false)}/>
            }
            <div className="cart-button-info-container">
                {drawInfoDependingOnOrderType()}
            </div>
        </>

    )
}

const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
    session: getSession(state.session)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartButtonInfoComponent));